export default __webpack_public_path__ + "static/media/download-solid.1cd9e186.svg";